export const convertProducts = (products = '') =>
  products.length ? products.split(',').map(str => str.trim()) : [];
